import { render, staticRenderFns } from "./AdminAppBar.vue?vue&type=template&id=0396fb92&scoped=true&"
import script from "./AdminAppBar.vue?vue&type=script&lang=js&"
export * from "./AdminAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396fb92",
  null
  
)

export default component.exports